



























































































import { Vue, Component, Emit, Watch } from 'vue-property-decorator';
import PagingUnit from '@/components/paging/paging.vue'; // 导入分页组件
import { TableStripe } from '@/mixins/tableStripe';
import CollapseTransition from '@/components/collapseTransition/collapseTransition';
import { dictServe, doublePrevention } from '@/api/installServer';
import publicProp from '@/views/emergencyDrills/plan/publicProp.vue';
import publishObjectPath from '@/util/configRegistry';
import Axios from 'axios';
import StatisticsPage from '@/views/emergencyDrills/plan/statisticsPage.vue';

@Component({
  components: { PagingUnit, CollapseTransition, publicProp, StatisticsPage },
  mixins: [TableStripe],
})
export default class RiskControlList extends Vue {
  private searchForm: any = {
    way: '', // 演练方式
    search: '', // 模糊搜索
    year: '', // 查询时间
  };

  wayList: any = []; // 应急队伍级别
  private tableLoading = false; // loading...
  private tableData: any = [];
  private queryDataForm: any = {
    pageNo: 1,
    pageSize: 10,
  };
  private total = 0;

  private showStatistics: any = false;

  private formShow = true; // 是否显示搜索表单内容
  isShowForm() {
    this.formShow = !this.formShow;
  }

  // 导入表格
  private headers: any = {};
  private fileList: any = [];
  private uploadUrl: any = publishObjectPath.serverUrl + '/api/yunnan/emergencyDrillPlan/import/data';

  // 点击按钮跳到相同的弹窗
  private jumpToPublicProp(type: any, data: any) {
    const passValue: any = {
      type: type,
      data: data,
    };
    if (type === 'delete') {
      this.$confirm('此操作将永久删除当前数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          doublePrevention.deleteEmergencyDrillPlan(data.id).then((res: any) => {
            if (res.code === '200') {
              this.$message.success('删除成功！');
              this.getTableData();
            } else {
              this.$message.warning('网络错误，请稍后再试！');
            }
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    } else {
      (this.$refs.publicProp as any).showDialog(passValue);
    }
  }

  private onSearch() {
    this.queryDataForm = {
      pageNo: 1,
      pageSize: 10,
    };
    this.getTableData();
  }

  private onReset() {
    this.searchForm = {
      way: '',
      search: '',
      timers: [],
    };
    this.queryDataForm = {
      pageNo: 1,
      pageSize: 10,
    };
    this.getTableData();
  }

  private getListData() {
    this.getTableData();
  }

  private getTableData() {
    this.tableLoading = true;
    doublePrevention
      .getEmergencyDrillPlan({
        // ...this.queryDataForm,
        current: this.queryDataForm.pageNo,
        size: this.queryDataForm.pageSize,
        way: this.searchForm.way ? this.searchForm.way : null, // 演练方式
        year: this.searchForm.year ? this.searchForm.year : null, // 年度
        search: this.searchForm.search ? this.searchForm.search : null, // 模糊搜索
      })
      .then((res: any) => {
        if (res.code === '200') {
          this.tableLoading = false;
          this.tableData = res.data.records;
          this.total = res.data.total;
          this.queryDataForm.pageSize = res.data.size;
        } else {
          this.$message.warning('获取数据失败！');
        }
      });
  }

  // 演练方式 的下拉
  getWayList() {
    dictServe.getDetailsMapByName('emergencyDrillWay').then((res: any) => {
      if (res.code === '200') {
        const helpArr: any = [];
        for (const key in res.data) {
          helpArr.push({
            value: key,
            label: res.data[key],
          });
        }
        this.wayList = helpArr;
        console.log(this.wayList);
      } else {
        this.$message.warning('获取应急队伍类型下拉数据失败！');
      }
    });
  }

  created() {
    this.headers.Authorization = localStorage.getItem('token');
    this.getTableData();
    this.getWayList();
  }
  // 导出数据
  exportData() {
    const serverUrlPath = publishObjectPath.serverUrl;
    const loading = this.$loading({
      lock: true,
      text: '下载中...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)',
    });
    Axios.defaults.headers['content-type'] = 'application/json;charset=UTF-8';
    Axios.defaults.headers.Authorization = localStorage.getItem('token');
    Axios({
      method: 'POST',
      url: serverUrlPath + '/api/yunnan/emergencyDrillPlan/export/excel', // 请求地址
      responseType: 'blob', // 表明返回服务器返回的数据类型
      data: {
        current: this.queryDataForm.pageNo,
        size: this.queryDataForm.pageSize,
        way: this.searchForm.way ? this.searchForm.way : null, // 演练方式
        year: this.searchForm.year ? this.searchForm.year : null, // 年度
        search: this.searchForm.search ? this.searchForm.search : null, // 模糊搜索
      },
    })
      .then(response => {
        // const disposition = response.headers["Content-disposition"];
        console.log(response);
        let fileName = '导出文件';
        try {
          const disposition = response.headers['content-disposition'];
          console.log(disposition);
          fileName = decodeURIComponent(disposition.split('filename = ')[1]); // 中文需要转码 (前端乱码为百分号形式）
        } catch (error) {
          fileName = '导出文件';
        }
        const blob = response.data;
        const a = document.createElement('a');
        a.download = fileName;
        a.style.display = 'none';
        a.href = URL.createObjectURL(blob);
        document.body.appendChild(a); // 修复firefox中无法触发click
        a.click();
        document.body.removeChild(a);
        loading.close();
        this.$message({
          type: 'success',
          message: '导出成功!',
        });
      })
      .catch(error => {
        loading.close();
        this.$message({
          type: 'error',
          message: '导出失败,请联系管理员!',
        });
        console.log(error);
      });
  }
  private downloadTemplate() {
    window.location.href = publishObjectPath.imgPathWater + '/doc/应急演练计划.xlsx';
  }

  private handleRemove(file: any, fileList: any) {
    this.fileList = fileList;
  }

  private handleExceed(files: any, fileList: any) {
    this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
  }

  private beforeAvatarUpload(files: any, fileList: any) {
    const suffix = files.name.substring(files.name.lastIndexOf('.') + 1);
    // console.log(suffix);
    if (suffix === 'xlsx') {
      return true;
    } else {
      this.$message.warning("请检查上传的文件是否是'xlsx'类型的！");
      return false;
    }
  }

  private handleAvatarCardFrontSuccess(file: any) {
    // console.log(file);
    if (file.code === '200') {
      this.getTableData();
      this.$message.success('导入表格成功！');
    } else {
      this.$message.warning('导入失败！');
    }
    this.fileList = [];
  }
  viewYearData() {
    this.showStatistics = true;
  }
  closePage() {
    this.showStatistics = false;
  }
}
